import { Box, Text, } from '@chakra-ui/react';
import React from 'react';

const PreviewExtra = ({ items }) => {
    return (
        <Box className='contentBox'>
            {Object.values(items).map((item) => {
              return (
                <Text className='subSections' >
                  <Box >
                    <Text className='name'>{item.organization}</Text>
                  </Box>
                  <Box><Text>{item.activities}</Text></Box>
                </Text>
              );
              },
            )}
        </Box>
    );
};
export default PreviewExtra;
